import { format$Price, formatPrice } from 'utils/helpers/functions/formatPrice';
import { withLocalCurrency } from 'utils/helpers/currency/currencyHelpers';

const formatItemAmount = (amount, isUahMode, showPlus = false) => {
    if (isUahMode) {
        return amount >= 0
            ? `${showPlus ? '+' : ''}${withLocalCurrency(formatPrice(amount))}`
            : withLocalCurrency(formatPrice(-amount), true);
    }
    return format$Price(amount, showPlus);
};

const ObjectCardInfoItem = ({
    title,
    icon,
    amount,
    amountTitle,
    secondAmount,
    secondAmountTitle,
    isUahMode = false,
    actionLabel,
    onAction,
}) => {
    const amountClass =
        amount > 0 ? 'is-positive' : amount < 0 ? 'is-negative' : '';

    return (
        <li className="object-analytics-item">
            <div className="object-analytics-item__icon" aria-hidden="true">
                {icon}
            </div>
            <div className="object-analytics-item__body">
                <div className="object-analytics-item__label-row">
                    <span className="object-analytics-item__label">{title}</span>
                    {actionLabel && onAction ? (
                        <button
                            type="button"
                            className="object-analytics-item__action"
                            onClick={onAction}
                        >
                            {actionLabel}
                        </button>
                    ) : null}
                </div>
                {amount || amount === 0 ? (
                    <span
                        className={`object-analytics-item__amount ${amountClass}`}
                        title={!isUahMode && amountTitle ? withLocalCurrency(formatPrice(amountTitle)) : ''}
                    >
                        {formatItemAmount(amount, isUahMode, true)}
                    </span>
                ) : (
                    <span className="object-analytics-item__amount">-</span>
                )}

                {secondAmount ? (
                    <span
                        className={`object-analytics-item__amount object-analytics-item__amount--secondary ${
                            secondAmount > 0 ? 'is-positive' : 'is-negative'
                        }`}
                        title={
                            !isUahMode && secondAmountTitle
                                ? withLocalCurrency(formatPrice(secondAmountTitle))
                                : ''
                        }
                    >
                        {formatItemAmount(secondAmount, isUahMode)}
                    </span>
                ) : null}
            </div>
        </li>
    );
};

export default ObjectCardInfoItem;
